import axios from 'axios'
import { getLocalStorage, removeLocalStorage} from '../../helpers/localStorage.js'


const BASE_URL = process.env.REACT_APP_BASE_URL

export const apiService = axios.create({
    baseURL: BASE_URL,
    withCredentials: true
})

apiService.interceptors.request.use(
    (config) => {
        let jwt = ''

        const identifynToken = getLocalStorage('identifyntoken')
            jwt = identifynToken

        if (jwt) {
            config.headers['Authorization'] = `Bearer ${jwt}`
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

apiService.interceptors.response.use(
    response => response,
    error => {
        if(error && error?.response?.status === 401) {
            removeLocalStorage('identifyntoken')
        }
        return Promise.reject(error?.response?.data)
    }
)